import {
    MILITARY_VARIANT,
    STC_VARIANT,
    collection,
    isMilitaryEnabled,
    parentTypeFor,
} from "../_variants/index.js";
import {
    editFlightCondition,
    linkFlightCondition,
    makeAddFlightCondition
} from "./actions.js";

/**
 * Build the attachable-table descriptor for the Flight Condition register that
 * matches the supplied variant.
 *
 * @param {import("../_variants/index.js").Variant} variant
 */
export const makeFlightConditionAttachable = (variant) => {
    const isMilitary = variant.key === "military";
    const label = isMilitary ? "Military Flight Conditions" : "Flight Conditions";
    const fcParentType = parentTypeFor(variant, "FlightConditions");
    const fcCollection = collection(variant, "FlightConditions");

    return {
        "label": label,
        "key": fcParentType,
        "location": `${fcCollection}/`,
        show() {
            return true
        },
        "actions": [{
            "label": `Add ${isMilitary ? "Military " : ""}Flight Condition`,
            "action": makeAddFlightCondition(variant),
            show({ meta }) {
                return meta?.ParentType === "Commercials" ? [true, ''] : [false, 'Can only add a new Flight Condition to a Commercial']
            }
        }, {
            "label": "Link Flight Condition",
            "action": linkFlightCondition
        }],
        "headers": [{
            "headerName": "Number",
            "field": "Number"
        }, {
            "headerName": "Title",
            "field": "Title"
        }, {
            "headerName": "Responsible Engineer",
            "field": "ResponsibleEngineer"
        }],
        "rowActions": [{
            "label": "Open Flight Condition",
            action({ router, rowItem }) {
                router.push(`/Database/${fcParentType}/${rowItem.ID}`)
            }
        }, {
            "label": "Edit Flight Condition",
            "action": editFlightCondition
        }]
    };
};

export const flightConditionAttachable = makeFlightConditionAttachable(STC_VARIANT);
export const militaryFlightConditionAttachable = isMilitaryEnabled()
    ? makeFlightConditionAttachable(MILITARY_VARIANT)
    : null;

export default flightConditionAttachable;
